export const SELECTABLE_VARIANT_ATTRIBUTES = [
  'size',
  'color',
  'material',
  'fit',
  'length',
  'width',
  'neckSize',
  'waist',
  'pattern',
  'garmentType',
  'style',
  'gender',
  'dosage',
  'form',
  'concentration',
  'flavor',
  'packSize',
] as const;

export type SelectableVariantAttribute = (typeof SELECTABLE_VARIANT_ATTRIBUTES)[number];

const SELECTABLE_VARIANT_ATTRIBUTE_SET = new Set<string>(SELECTABLE_VARIANT_ATTRIBUTES);

export function isSelectableVariantAttribute(attributeName: string): boolean {
  return SELECTABLE_VARIANT_ATTRIBUTE_SET.has(attributeName);
}

export function buildVariantDetails(
  variant: Record<string, unknown> | null | undefined
): Record<string, string> | undefined {
  if (!variant) {
    return undefined;
  }

  const details: Record<string, string> = {};
  for (const key of SELECTABLE_VARIANT_ATTRIBUTES) {
    const value = variant[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      details[key] = String(value);
    }
  }

  return Object.keys(details).length > 0 ? details : undefined;
}

export function getDisplayVariantDetails(
  details: Record<string, string | undefined> | undefined
): Array<[string, string]> {
  if (!details) {
    return [];
  }

  return Object.entries(details).filter(
    ([key, value]) => Boolean(value) && isSelectableVariantAttribute(key)
  ) as Array<[string, string]>;
}

export function getVariantAttributeFallbackLabel(attributeName: string): string {
  return attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
}

export function resolveVariantAttributeLabel(
  key: string,
  translate: (messageKey: string) => string,
  hasMessage: (messageKey: string) => boolean
): string {
  const labelKey = `product.attributeLabels.${key}`;
  return hasMessage(labelKey)
    ? translate(labelKey)
    : getVariantAttributeFallbackLabel(key);
}
